import { useEffect } from 'react';

const setMeta = (selector, attr, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [key, value] = selector.replace(/^meta\[|\]$/g, '').replace(/"/g, '').split('=');
    el.setAttribute(key, value);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, content);
};

// Per-route SEO for the SPA: title, description, canonical and optional JSON-LD.
export const useSeo = ({ title, description, path, jsonLd }) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;
    setMeta('meta[name="description"]', 'content', description);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);

    const canonical = document.head.querySelector('link[rel="canonical"]');
    const prevCanonical = canonical?.getAttribute('href');
    canonical?.setAttribute('href', `https://jesssellseastcoast.com${path}`);

    let script;
    if (jsonLd) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.title = prevTitle;
      if (prevCanonical) canonical?.setAttribute('href', prevCanonical);
      script?.remove();
    };
  }, [title, description, path, jsonLd]);
};
